import React, { useMemo } from 'react';

import { ToolkitFeatureFlag } from '@cko/primitives';
import { useRouteMatch } from 'react-router-dom';
import { AvailableInternalLinkMenuItem } from '../../../../providers/NavigationProvider/types';
import { useNavigation } from '../../../../providers/NavigationProvider';
import { SideNavLevelOneLink } from './SideNavLevelOneLink';
import { SideNavLevelTwoLink } from './SideNavLevelTwoLink';
import { StyledBlockedLinkWrapper } from './SideNavMenuItemLink.styles';

type SideNavMenuItemLinkProps = {
  menuItemConfig: AvailableInternalLinkMenuItem;
  level?: 1 | 2;
  // This prop is used to prevent focus on the link with keyboard navigation if contained inside a closed menu accordion
  preventFocus?: boolean;
};

export const SideNavMenuItemLink = ({
  menuItemConfig,
  level = 1,
  preventFocus,
}: SideNavMenuItemLinkProps) => {
  const { routeId } = menuItemConfig;
  const { getRouteById } = useNavigation();

  const routePath = useMemo(() => {
    const routeConfig = getRouteById(routeId);
    return routeConfig?.path || '';
  }, [routeId]);

  const exact = useMemo(() => routePath === '/', [routePath]);
  const match = useRouteMatch({ path: routePath, exact });
  const isActiveRoute = Boolean(match);

  if (level === 1) {
    return (
      <StyledBlockedLinkWrapper
        requiredAccountLevels={menuItemConfig.requiredAccountLevels}
        linkType="primary"
        to={routePath}
      >
        {({ isBlocked }) => (
          <SideNavLevelOneLink
            exact={exact}
            isActiveRoute={isActiveRoute}
            isBlocked={isBlocked}
            routePath={routePath}
            menuItemConfig={menuItemConfig}
          />
        )}
      </StyledBlockedLinkWrapper>
    );
  }

  return (
    <ToolkitFeatureFlag flag="v10">
      <StyledBlockedLinkWrapper
        requiredAccountLevels={menuItemConfig.requiredAccountLevels}
        linkType="primary"
        to={routePath}
      >
        {({ isBlocked }) => (
          <SideNavLevelTwoLink
            exact={exact}
            isActiveRoute={isActiveRoute}
            isBlocked={isBlocked}
            routePath={routePath}
            menuItemConfig={menuItemConfig}
            preventFocus={preventFocus}
          />
        )}
      </StyledBlockedLinkWrapper>
    </ToolkitFeatureFlag>
  );
};
